import React from 'react';
import DateLineChart from '../../../Layout/Chart/DateLineChart';
import { IMeasurement } from '../../types';

interface IMeasurementHistoryChartProps {
  history?: IMeasurement[];
  trend?: number;
  period: {
    start: string;
    end: string;
  };
}

const MeasurementHistoryChart: React.FC<IMeasurementHistoryChartProps> = ({
  history = undefined,
  trend = undefined,
  period,
}) => {
  const reversedMeasurements = [...(history as IMeasurement[])].reverse();
  if (reversedMeasurements.length) {
    const theFirstMeasurements = reversedMeasurements[0];
    if (theFirstMeasurements.date !== period.start) {
      reversedMeasurements.unshift({
        value: undefined,
        date: period.start,
      });
    }

    const theLastMeasurement = reversedMeasurements[reversedMeasurements.length - 1];
    if (theLastMeasurement.date !== period.end) {
      reversedMeasurements.push({
        ...theLastMeasurement,
        date: period.end,
      });
    }
  }

  const series = [
    {
      name: 'values',
      data: reversedMeasurements.map((measurement) => ({
        x: new Date(measurement.date as string),
        y: measurement.value,
      })),
      meta: {
        showPoint: true,
        showArea: true,
      },
    },
  ];

  if (trend != null) {
    series.push({
      name: 'goal',
      data: [
        {
          x: new Date(period.start),
          y: trend,
        },
        {
          x: new Date(period.end),
          y: trend,
        },
      ],
      meta: { showPoint: false, showArea: false },
    });
  }

  return <DateLineChart series={series} />;
};

export default MeasurementHistoryChart;
